//retorno tola información del usuario logueado
export function userInfoGetter(state) {  
    return state.user;
}

